import i18n from 'modules/core/lib/i18n'
import { useNavigate } from 'react-router-dom'
import { ExternalLink } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { InsightTableType } from 'modules/finance/components/FinancialWorkspace/types/table'
import { useOnExport } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/exports/useExport'
import { resolveTitle } from 'modules/finance/components/FinancialWorkspacePayroll/components/Table/const'
import { usePayrollGroupData } from 'modules/finance/components/FinancialWorkspacePayroll/hooks/usePayrollGroupData'

import { GroupBySelector } from './GroupBy'

export const useTableProps = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const gotoCompensations = () => {
    track(trackingEvents.accounting.newFinancialWorkspace.compensation.navigateToCompensations)
    navigate(navigation.compensations.fullPath())
  }

  return {
    useOnExport,
    titleResolver: resolveTitle,
    groupByComponent: GroupBySelector,
    useDataFetch: usePayrollGroupData,
    emptyStateProps: {
      emoji: '📄',
      filtersEmoji: '🔍',
      actions: () => [
        {
          icon: ExternalLink,
          onClick: gotoCompensations,
          variant: 'outline' as const,
          label: i18n.t('finance.financial_workspace.compensations.upload_banner.cta.upload'),
        },
      ],
      title: i18n.t('finance.financial_workspace.breakdown_table.empty_state.payroll.title'),
      description: i18n.t(
        'finance.financial_workspace.breakdown_table.empty_state.payroll.description'
      ),
    },
    type: InsightTableType.Payroll,
  }
}
